import { education } from '../../copy/onboardingCopy.json';

export const getHeaderListItems = ({
  educationLevel,
  tenantName,
  careerOrDegree = null,
  isOnAdvisorDashboard = false,
  canSeeAdvisorDashboard = false,
  translations = false,
}) => {
  const listItemsArray = ['careerSearch', 'degreeSearch', 'logout'].filter(
    (option) => !option.includes(careerOrDegree)
  );

  if (['ASU'].includes(tenantName) && educationLevel === education.degree2)
    listItemsArray.splice(0, 0, 'ecap');
  if (['SMC'].includes(tenantName))
    listItemsArray.splice(listItemsArray.length - 1, 0, 'myPath2ASU');
  if (isOnAdvisorDashboard) {
    listItemsArray.splice(listItemsArray.length - 1, 0, 'myDashboard');
  }
  if (canSeeAdvisorDashboard) {
    listItemsArray.splice(listItemsArray.length - 1, 0, 'advisorDashboard');
  }
  if (translations && ['ASU', 'Baobab'].includes(tenantName)) {
    listItemsArray.splice(listItemsArray.length - 1, 0, 'translations');
  }

  return listItemsArray;
};
